var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 15h-7v7c0 .553-.447 1-1 1-.553 0-1-.447-1-1v-7H6c-.552 0-1-.447-1-1 0-.553.448-1 1-1h7V6c0-.552.447-1 1-1 .553 0 1 .448 1 1v7h7c.553 0 1 .447 1 1 0 .553-.447 1-1 1z",
    transform: "translate(-842 -258) translate(560 248) translate(282 10) rotate(45 14 14)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.05d961c6691673b3dd3a115d04627292.svg";
export { ForwardRef as ReactComponent };